import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SessionExpiredService } from './sessionExpired.service';

// "Start video call" links emailed to SSO users land directly on the call
// page with the SSO token as ?t=... . Sign the user in exactly like
// sso-landing.component.ts does, then re-navigate without `t` so the token
// doesn't linger in the address bar/history. Must run before AuthGuardfor.
// In-app "Start Video Call" clicks carry no `t` and pass straight through.
@Injectable({ providedIn: 'root' })
export class SsoEmailTokenGuard implements CanActivateChild {
  private readonly callPath = '/home/servicePage/advancedConsultation/call-component';

  constructor(private cookie: CookieService, private router: Router, private sessionExpired: SessionExpiredService) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = route.queryParamMap.get('t');
    if (!token || state.url.split('?')[0] !== this.callPath) {
      return true;
    }

    this.cookie.set('token', token);
    this.cookie.set('primaryToken', token);
    this.cookie.set('sso_user', 'true');
    localStorage.setItem('sso_user', 'true');
    this.sessionExpired.markSsoSession();

    const queryParams = Object.assign({}, route.queryParams);
    delete queryParams['t'];
    this.router.navigate([this.callPath], { queryParams: queryParams, replaceUrl: true });
    return false;
  }
}
